(() => {
  const KEY = "ls_wishlist_v1";

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
    catch(e){ return []; }
  };

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: "GBP" }).format((cents || 0) / 100);
    } catch(e){
      return "£" + ((cents || 0) / 100).toFixed(2);
    }
  };

  const fetchProduct = async (handle) => {
    const res = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
    if (!res.ok) throw new Error("Failed " + handle);
    return res.json();
  };

  const renderCard = (p) => {
    const img = (p.images && p.images[0]) ? p.images[0] : "";
    const price = (p.variants && p.variants[0]) ? p.variants[0].price : 0;

    return `
      <a class="wishlist-card" href="${p.url}">
        <div class="wishlist-card__img">
          ${img ? `<img src="${img}" alt="${(p.title || "").replaceAll('"','&quot;')}" loading="lazy">` : ``}
        </div>
        <div class="wishlist-card__meta">
          <p class="wishlist-card__title">${p.title || ""}</p>
          <p class="wishlist-card__price">${money(price)}</p>
        </div>
      </a>
    `;
  };

  const init = async () => {
    const grid = document.querySelector("[data-wishlist-grid]");
    const empty = document.querySelector(".wishlist-page__empty");
    if (!grid) return;

    const handles = read().filter(Boolean);
    if (!handles.length) {
      empty?.removeAttribute("hidden");
      grid.innerHTML = "";
      return;
    }

    empty?.setAttribute("hidden", "hidden");

    const results = [];
    for (const h of handles) {
      try { results.push(await fetchProduct(h)); }
      catch(e) {}
    }

    if (!results.length) {
      empty?.removeAttribute("hidden");
      grid.innerHTML = "";
      return;
    }

    grid.innerHTML = results.map(renderCard).join("");
  };

  document.addEventListener("DOMContentLoaded", init);
  window.addEventListener("ls:wishlist-changed", init);
})();
